import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_instance1ws7d9j63nohl as Companion_instance } from '../../../../../../../okio-parent-okio/okio/HashingSink.mjs';
import {
  blackholeSink1e341pykjnhp5 as blackholeSink,
  buffer10rjf0ze3bqic as buffer,
} from '../../../../../../../okio-parent-okio/okio/Okio.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from '../../../../../../../kotlinx-atomicfu/kotlinx/atomicfu/locks/Synchronized.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ApolloNetworkException3denf70pfh242 as ApolloNetworkException } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { SubscribableWebSockethkxzhdarcovi as SubscribableWebSocket } from './SubscribableWebSocket.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function cleanupLocked($this, key) {
  // Inline function 'kotlin.collections.iterator' call
  var iterator = $this.m67_1.l3().p1();
  while (iterator.q1()) {
    var entry = iterator.r1();
    if (entry.n3().r68(entry.m3().equals(key))) {
      iterator.p6();
    }
  }
}
function closeAllConnectionsLocked($this, cause) {
  // Inline function 'kotlin.collections.iterator' call
  var iterator = $this.m67_1.l3().p1();
  while (iterator.q1()) {
    var entry = iterator.r1();
    entry.n3().p68(cause, 1001, 'Client requested closing the connection');
    iterator.p6();
  }
}
function key($this, url, httpHeaders) {
  var hashingSink = Companion_instance.f3x(blackholeSink());
  // Inline function 'kotlin.apply' call
  var this_0 = buffer(hashingSink);
  this_0.u3w(url);
  this_0.w3w(0);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = httpHeaders.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    this_0.u3w(element.w48_1 + ': ' + element.x48_1);
    this_0.w3w(0);
  }
  this_0.oc();
  return hashingSink.i3x();
}
var WebSocketPoolClass;
function WebSocketPool() {
  if (WebSocketPoolClass === VOID) {
    class $ {
      constructor(webSocketEngine, serverUrl, wsProtocol, connectionAcknowledgeTimeout, pingInterval, idleTimeout) {
        this.f67_1 = webSocketEngine;
        this.g67_1 = serverUrl;
        this.h67_1 = wsProtocol;
        this.i67_1 = connectionAcknowledgeTimeout;
        this.j67_1 = pingInterval;
        this.k67_1 = idleTimeout;
        var tmp = this;
        // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
        tmp.l67_1 = get_atomicfu$reentrantLock();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.m67_1 = LinkedHashMap().ec();
      }
      l6() {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.l67_1;
        closeAllConnectionsLocked(this, ApolloNetworkException().d47('WebSocketNetworkTransport was closed'));
        this.f67_1.l6();
        return Unit_instance;
      }
      n67(apolloRequest) {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.l67_1;
        var tmp0_elvis_lhs = apolloRequest.x40_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.g67_1 : tmp0_elvis_lhs;
        var tmp;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = "ApolloRequest.url is missing for request '" + apolloRequest.s40_1.operationName() + "', did you call ApolloClient.Builder.webSocketServerUrl(url)?";
          throw IllegalStateException().o(toString(message));
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var url = tmp;
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs_0 = apolloRequest.z40_1;
        var httpHeaders = tmp0_elvis_lhs_0 == null ? emptyList() : tmp0_elvis_lhs_0;
        var key_0 = key(this, url, httpHeaders);
        cleanupLocked(this, key_0);
        var webSocket = this.m67_1.u4(key_0);
        if (webSocket == null) {
          webSocket = new (SubscribableWebSocket())(this.f67_1, url, httpHeaders, this.h67_1, this.j67_1, this.i67_1, this.k67_1);
          this.m67_1.x4(key_0, webSocket);
        }
        return webSocket;
      }
    }
    initMetadataForClass($, 'WebSocketPool');
    WebSocketPoolClass = $;
  }
  return WebSocketPoolClass;
}
//region block: exports
export {
  WebSocketPool as WebSocketPool28m608awosr6h,
};
//endregion

//# sourceMappingURL=WebSocketPool.mjs.map
